import {useContext} from "react";
import {OperationalEntityContext} from "./OperationalEntityContext";
import {OperationalEntityContextValue} from "./OperationalEntityContextValue";

export function useOperationalEntity(): OperationalEntityContextValue {
  return useContext(OperationalEntityContext);
}
